import type { User } from "@/types"

export const isWaitlisted = (user: User) => user.status === "waitlisted"
export const isVerified = (user: User) => user.verified
export const isApproved = (user: User) => user.status === "approved"
